import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { CadsProcessingSpinnerConfig } from './cads-processing-spinner.config';

/** Number of dot arms in the inline chase animation. */
const CADS_PROCESSING_SPINNER_ARM_COUNT = 8;

/**
 * Inline dot-chase processing indicator sized for buttons, toggles, and other compact slots. Inspired by legacy
 * `bw-spinner-legacy` / {@link CadsSpinnerComponent}, but built with a centered CSS orbit so **default** (24px) and
 * **compact** (20px) presets stay crisp without layout overflow.
 */
@Component({
  selector: 'cads-processing-spinner',
  standalone: true,
  templateUrl: './cads-processing-spinner.component.html',
  styleUrl: './cads-processing-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsProcessingSpinnerComponent {
  readonly config = input<CadsProcessingSpinnerConfig>({});

  protected readonly _arms = Array.from({ length: CADS_PROCESSING_SPINNER_ARM_COUNT }, (_, index) => index);

  protected readonly _isCompact = computed(() => this.config().size === 'compact');

  protected readonly _color = computed(
    () => this.config().color?.trim() || 'var(--cads-color-blue)',
  );

  protected readonly _accessibleLabel = computed((): string | null => {
    const fromConfig = this.config().accessibleLabel;
    if (fromConfig !== undefined) {
      const trimmed = fromConfig.trim();
      return trimmed.length > 0 ? trimmed : null;
    }
    return 'Loading';
  });
}
